module.exports = __webpack_public_path__ + "media/images/linkedin-4cba4beb035c01e71c1706471f0eb9c2.svg";